export var ModelActionHelper;
(function (ModelActionHelper) {
  // several ModelAction properties support static value or a function.
  // this method checks for functions and executes all of them to receive plain data.
  // eslint-disable-next-line no-inner-declarations
  function processItemActionProperties(action, item) {
    return ['label', 'title', 'icon', 'styleClass'].reduce((processed, property) => {
      if (action[property]) {
        if (typeof action[property] === 'function') processed[property] = action[property](item);else if (typeof action[property] === 'string') processed[property] = action[property];
      }
      return processed;
    }, {});
  }
  ModelActionHelper.processItemActionProperties = processItemActionProperties;
})(ModelActionHelper || (ModelActionHelper = {}));